import React, { useContext, useEffect, useRef, useState } from "react";
import secondaryComponents from "../../../../../components/secondaryComponents";
import primaryComponents from "../../../../../components/primaryComponents";
// import Icon from "../../../../../assets/icons";
import { GRID_PRODUCT_DEFAULT_ICONS } from "../../../../../helpers/constants";
import styles from "./styles.module.scss";
import { ToastContext } from "../../../../../hooks/context";
import {
  findPricingViaIdHelper,
  formatCurrency,
  getSellingPriceWithoutDiscount,
} from "../../../../../helpers";
import { useDispatch } from "react-redux";
import { addToMenuCart } from "../../../../../store/modules/menuCart";
import {
  ChevronLeftArrow,
  ChevronRightArrow,
} from "../../../../../assets/svgIcons";
import Icon from "../../../../../assets/icons";
import parse from "html-react-parser";

const ITEM_WIDTH = 84;

const VariantItem = ({
  productIndex,
  variantItem,
  variantQuantity,
  setVariantQuantity,
  productItem,
  primaryColor,
}) => {
  const triggerToast = useContext(ToastContext);
  const pricingDetails = findPricingViaIdHelper(
    1,
    variantItem?.["store_variant_properties"][0]?.pricings,
  );

  return (
    <div className={styles.variantItemContainer}>
      <div className={styles.variantImgContainer}>
        <img
          src={
            variantItem?.image_url
              ? variantItem?.image_url
              : GRID_PRODUCT_DEFAULT_ICONS[productIndex % 5]
          }
          className={styles.variantImg}
          alt=""
        />
      </div>
      <div className={styles.variantContent}>
        <h6>
          {variantItem.option} -- {variantItem.value}
        </h6>
        <p className={styles.description}>
          {formatCurrency({
            value:
              pricingDetails?.unit_price *
              (variantQuantity[productIndex].quantity || 1),
            currencyCode: productItem?.store?.currency_code,
          })}{" "}
          {pricingDetails?.discount_rate > 0 && (
            <span className={`error--text ${styles.productPrice}`}>
              <span style={{ textDecoration: "line-through" }}>
                {formatCurrency({
                  value:
                    getSellingPriceWithoutDiscount({
                      vat_percent: productItem?.vat,
                      inputed_selling_price: pricingDetails?.price,
                      discount_rate: pricingDetails?.discount_rate,
                      include_vat_in_price: productItem?.include_vat_in_price,
                    }) * (variantQuantity[productIndex].quantity || 1),
                })}
              </span>{" "}
              {pricingDetails?.discount_rate}% OFF
            </span>
          )}
        </p>
      </div>
      <div className={styles.selectButtonsContainer}>
        <div
          onClick={() =>
            setVariantQuantity((prev) =>
              prev.map((item) =>
                item.index === productIndex
                  ? {
                      index: productIndex,
                      quantity:
                        prev[productIndex].quantity > 0
                          ? prev[productIndex].quantity - 1
                          : prev[productIndex].quantity,
                    }
                  : item,
              ),
            )
          }
          className={styles.decrement}
          style={{ borderColor: primaryColor }}
        >
          -
        </div>
        <primaryComponents.CartInputField
          value={variantQuantity[productIndex].quantity}
          style={{ height: 32, margin: "0 8px" }}
          updateCart={() => {}}
          onChange={(e) => {
            if (
              variantItem.store_variant_properties[0]?.stock_quantity === 0 &&
              variantItem?.composite_product_type !== "ON_DEMAND"
            )
              return triggerToast("Product is out of stock", "warning");
            if (
              e.target.value >
              variantItem.store_variant_properties[0]?.stock_quantity
            )
              return triggerToast(
                `Quantity can not be more than available quantity of ${variantItem.store_variant_properties[0]?.stock_quantity} for item ( ${variantItem.option} -- ${variantItem.value} )`,
                "warning",
              );

            setVariantQuantity((prev) =>
              prev.map((item) =>
                item.index === productIndex
                  ? {
                      index: productIndex,
                      quantity: e.target.value,
                    }
                  : item,
              ),
            );
          }}
        />
        <div
          onClick={() => {
            if (
              variantItem.store_variant_properties[0]?.stock_quantity === 0 &&
              variantItem?.composite_product_type !== "ON_DEMAND"
            )
              return triggerToast("Product is out of stock", "warning");

            setVariantQuantity((prev) =>
              prev.map((item) =>
                item.index === productIndex
                  ? {
                      index: productIndex,
                      quantity: prev[productIndex].quantity + 1,
                    }
                  : item,
              ),
            );
          }}
          className={styles.increment}
          style={{ background: primaryColor }}
        >
          +
        </div>
      </div>
    </div>
  );
};

const AddToCartModal = ({
  productIndex,
  showAddToCartModal: productItem,
  setShowAddToCartModal,
  menuObjectDetail,
}) => {
  const containerRef = useRef();
  const dispatch = useDispatch();
  const triggerToast = useContext(ToastContext);

  const [currentImage, setCurrentImage] = useState(productItem?.media_files[0]);
  const [scrollPosition, setScrollPosition] = useState(0);

  const [quantity, setQuantity] = useState(1);
  const [variantQuantity, setVariantQuantity] = useState(
    new Array(productItem?.variants?.length)
      .fill("")
      .map((_, index) => ({ index, quantity: 0 })),
  );

  const primaryColor = menuObjectDetail?.primary_colour
    ? menuObjectDetail?.primary_colour
    : "#7647ee";

  const handleAddVariantToCart = () => {
    if (
      (productItem?.is_service
        ? productItem?.store_service_properties[0]?.stock_quantity === 0
        : productItem?.store_product_properties[0]?.stock_quantity === 0) &&
      productItem?.composite_product_type !== "ON_DEMAND"
    )
      return triggerToast("Product is out of stock", "warning");

    variantQuantity.forEach((variant) => {
      if (variant.quantity > 0) {
        dispatch(
          addToMenuCart({
            id: productItem.variants[variant.index].id,
            is_variant: true,
            is_service: productItem.is_service,
            variant: productItem.variants[variant.index],
            productId: productItem.id,
            image_url: productItem.variants[variant.index]?.image_url
              ? productItem.variants[variant.index]?.image_url
              : null,
            name: `${productItem.name} -- ${productItem.variants[variant.index].option}: ${
              productItem.variants[variant.index].value
            }`,
            quantity: variant.quantity,
            pricing_type:
              productItem.variants?.[variant.index]
                ?.store_variant_properties?.[0]?.pricings?.[0]?.pricing_type ||
              null,
            store: productItem.store,
            store_variant_properties:
              productItem.variants[variant.index].store_variant_properties,
          }),
        );
      }
    });
    triggerToast("Item(s) added to cart", "success");
    setShowAddToCartModal(null);
  };

  const handleHorizontalScroll = (scrollAmount) => {
    const newScrollPosition = scrollPosition + scrollAmount;

    setScrollPosition(newScrollPosition);

    containerRef.current.scrollLeft = newScrollPosition;
  };

  const getCurrentIndex = () =>
    productItem?.media_files?.findIndex((item) => item === currentImage);

  const handleRightClick = () => {
    const currentIndex = getCurrentIndex();
    if (currentIndex < productItem?.media_files?.length - 1) {
      setCurrentImage(productItem?.media_files[currentIndex + 1]);
    }
    handleHorizontalScroll(-ITEM_WIDTH);
  };

  const handleLeftClick = () => {
    const currentIndex = getCurrentIndex();
    if (currentIndex > 0) {
      setCurrentImage(productItem?.media_files[currentIndex - 1]);
    }
    handleHorizontalScroll(ITEM_WIDTH);
  };

  const productKey = productItem.is_service
    ? "store_service_properties"
    : "store_product_properties";

  const pricingDetails = findPricingViaIdHelper(
    productItem?.pricing_type?.id,
    productItem?.[productKey][0]?.pricings,
  );

  useEffect(() => {
    if (scrollPosition < 0) {
      setScrollPosition(0);
    }
  }, [scrollPosition]);

  return (
    <secondaryComponents.Modal
      width={productItem?.variants?.length > 0 ? "729px" : "600px"}
      isActive={productItem ? true : false}
      closeModal={() => setShowAddToCartModal(null)}
    >
      {productItem?.variants?.length > 0 ? (
        <div className={styles.variantModalContainer}>
          <img
            onClick={() => setShowAddToCartModal(null)}
            src={Icon.close}
            className={styles.closeIcon}
            alt=""
          />
          <div className={styles.imgContainer}>
            <img
              src={
                productItem?.media_files?.length > 0
                  ? currentImage?.url
                  : productItem?.image_url
                    ? productItem?.image_url
                    : GRID_PRODUCT_DEFAULT_ICONS[productIndex % 5]
              }
              className={styles.productImg}
              alt=""
            />
          </div>
          {productItem &&
            productItem.media_files &&
            productItem.media_files.length > 0 && (
              <div className={styles.baseImagesContainer}>
                <div
                  onClick={handleLeftClick}
                  style={{
                    borderColor: primaryColor,
                    opacity: getCurrentIndex() === 0 ? 0.3 : 1,
                    cursor: getCurrentIndex() === 0 ? "default" : "pointer",
                  }}
                  className={styles.arrowContainer}
                >
                  <ChevronLeftArrow color={primaryColor} />
                </div>

                <div ref={containerRef} className={styles.imagesContainer}>
                  {productItem.media_files.map((image) => (
                    <div key={image.id}>
                      <div
                        onClick={() => setCurrentImage(image)}
                        className={styles.imageItem}
                        style={{
                          borderColor:
                            image === currentImage
                              ? "#7647ee"
                              : "rgba(197, 197, 197, 1)",
                        }}
                      >
                        <img src={image.url} alt="" />
                        {image !== currentImage && (
                          <div className={styles.imageCover} />
                        )}
                      </div>
                    </div>
                  ))}
                </div>
                <div
                  onClick={handleRightClick}
                  style={{
                    borderColor: primaryColor,
                    opacity:
                      getCurrentIndex() === productItem?.media_files?.length - 1
                        ? 0.3
                        : 1,
                    cursor:
                      getCurrentIndex() === productItem?.media_files?.length - 1
                        ? "default"
                        : "pointer",
                  }}
                  className={styles.arrowContainer}
                >
                  <ChevronRightArrow color={primaryColor} />
                </div>
              </div>
            )}

          <div className={styles.contentContainer}>
            <h4>{productItem.name}</h4>
            {productItem.description && (
              <div className={styles.descriptionContainer}>
                <div className={styles.detailsContainer}>
                  <p>Description</p>
                </div>
                <div>{parse(productItem.description)}</div>
              </div>
            )}
            <div className={styles.variantContainer}>
              <p>Variants</p>
              <div className={styles.variants}>
                {productItem.variants.map((variantItem, index) => (
                  <VariantItem
                    key={index}
                    productIndex={index}
                    variantItem={variantItem}
                    variantQuantity={variantQuantity}
                    setVariantQuantity={setVariantQuantity}
                    productItem={productItem}
                    primaryColor={primaryColor}
                  />
                ))}
              </div>
            </div>
            <primaryComponents.Button
              classNames={`btn btn--primary cover ${styles.button}`}
              isDisabled={
                variantQuantity.find((item) => item.quantity > 0) ? false : true
              }
              onClick={handleAddVariantToCart}
              style={{ background: primaryColor }}
            >
              Add{" "}
              {variantQuantity?.reduce(
                (acc, item) => acc + Number(item?.quantity || 0),
                0,
              )}{" "}
              item(s) to cart
            </primaryComponents.Button>
          </div>
        </div>
      ) : (
        <div className={styles.modalContainer}>
          <img
            onClick={() => setShowAddToCartModal(null)}
            src={Icon.close}
            className={styles.closeIcon}
            alt=""
          />
          <div className={styles.imgContainer}>
            <img
              src={
                productItem?.media_files?.length > 0
                  ? currentImage?.url
                  : productItem?.image_url
                    ? productItem?.image_url
                    : GRID_PRODUCT_DEFAULT_ICONS[productIndex % 5]
              }
              className={styles.productImg}
              alt=""
            />
          </div>

          {productItem?.media_files?.length > 0 && (
            <div className={styles.baseImagesContainer}>
              <div
                onClick={handleLeftClick}
                style={{
                  borderColor: primaryColor,
                  opacity: getCurrentIndex() === 0 ? 0.3 : 1,
                  cursor: getCurrentIndex() === 0 ? "default" : "pointer",
                }}
                className={styles.arrowContainer}
              >
                <ChevronLeftArrow color={primaryColor} />
              </div>
              <div ref={containerRef} className={styles.imagesContainer}>
                {productItem?.media_files?.map((image) => (
                  <div key={image.id}>
                    <div
                      onClick={() => setCurrentImage(image)}
                      className={styles.imageItem}
                      style={{
                        borderColor:
                          image === currentImage
                            ? primaryColor
                            : "rgba(197, 197, 197, 1)",
                      }}
                    >
                      <img src={image.url} alt="" />
                      {image !== currentImage && (
                        <div className={styles.imageCover} />
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <div
                onClick={handleRightClick}
                style={{
                  borderColor: primaryColor,
                  opacity:
                    getCurrentIndex() === productItem?.media_files?.length - 1
                      ? 0.3
                      : 1,
                  cursor:
                    getCurrentIndex() === productItem?.media_files?.length - 1
                      ? "default"
                      : "pointer",
                }}
                className={styles.arrowContainer}
              >
                <ChevronRightArrow color={primaryColor} />
              </div>
            </div>
          )}

          <div className={styles.contentContainer}>
            <h4>{productItem.name}</h4>
            <p style={{ color: primaryColor }} className={styles.description}>
              {formatCurrency({
                value: pricingDetails?.unit_price * (quantity || 1),
                currencyCode: productItem?.store?.currency_code,
                decimal: 2,
              })}{" "}
              {pricingDetails?.discount_rate ? (
                <span className={`error--text ${styles.productPrice}`}>
                  <span style={{ textDecoration: "line-through" }}>
                    {formatCurrency({
                      value:
                        getSellingPriceWithoutDiscount({
                          vat_percent: productItem?.vat,
                          inputed_selling_price: pricingDetails?.price,
                          discount_rate: pricingDetails?.discount_rate,
                          include_vat_in_price:
                            productItem?.include_vat_in_price,
                        }) * (quantity || 1),
                      currencyCode: productItem?.store?.currency_ode,
                      decimal: 2,
                    })}
                  </span>{" "}
                  {pricingDetails?.discount_rate}% OFF
                </span>
              ) : null}
            </p>
            {productItem.description && (
              <>
                <div className={styles.detailsContainer}>
                  <p>Description</p>
                </div>
                <div>{parse(productItem.description)}</div>
              </>
            )}
            <div className={styles.separator} />
            <div className={styles.baseContainer}>
              <div className={styles.selectQuantityContainer}>
                <p>Select quantity</p>
                <div className={styles.selectButtonsContainer}>
                  <div
                    onClick={() =>
                      setQuantity((prev) => (prev > 1 ? prev - 1 : prev))
                    }
                    className={styles.decrement}
                    style={{ borderColor: primaryColor }}
                  >
                    -
                  </div>
                  <primaryComponents.CartInputField
                    value={quantity}
                    style={{ height: 32, margin: "0 8px" }}
                    updateCart={() => {}}
                    onChange={(e) => {
                      if (
                        (productItem.is_service
                          ? productItem?.store_service_properties[0]
                              ?.stock_quantity === 0
                          : productItem?.store_product_properties[0]
                              ?.stock_quantity === 0) &&
                        productItem?.composite_product_type !== "ON_DEMAND"
                      )
                        return triggerToast(
                          "Product is out of stock",
                          "warning",
                        );
                      if (
                        e.target.value >
                        (productItem.is_service
                          ? productItem?.store_service_properties[0]
                              ?.stock_quantity === 0
                          : productItem?.store_product_properties[0]
                              ?.stock_quantity === 0)
                      )
                        return triggerToast(
                          `Quantity can not be more than available quantity of ${productItem.store_properties.stock_quantity} for item ( ${productItem.product.name} )`,
                          "warning",
                        );

                      setQuantity(e.target.value);
                    }}
                  />
                  <div
                    onClick={() => {
                      if (
                        (productItem.is_service
                          ? productItem?.store_service_properties[0]
                              ?.stock_quantity === 0
                          : productItem?.store_product_properties[0]
                              ?.stock_quantity === 0) &&
                        productItem?.composite_product_type !== "ON_DEMAND"
                      )
                        return triggerToast(
                          "Product is out of stock",
                          "warning",
                        );

                      setQuantity((prev) => prev + 1);
                    }}
                    className={styles.increment}
                    style={{ background: primaryColor }}
                  >
                    +
                  </div>
                </div>
              </div>
              <div className={styles.button}>
                <primaryComponents.Button
                  style={{ background: primaryColor }}
                  classNames={"btn btn--primary cover"}
                  isDisabled={quantity < 1}
                  onClick={() => {
                    if (
                      (productItem.is_service
                        ? productItem?.store_service_properties[0]
                            ?.stock_quantity === 0
                        : productItem?.store_product_properties[0]
                            ?.stock_quantity === 0) &&
                      productItem?.composite_product_type !== "ON_DEMAND"
                    )
                      return triggerToast("Product is out of stock", "warning");

                    dispatch(
                      addToMenuCart({
                        id: productItem?.id,
                        is_variant: false,
                        is_service: productItem.is_service,
                        productId: productItem?.id,
                        image_url:
                          productItem?.media_files?.length > 0
                            ? currentImage?.url
                            : productItem?.image_url,
                        name: productItem?.name,
                        quantity,
                        pricing_type: productItem?.pricing_type,
                        store: productItem?.store,
                        store_product_properties:
                          productItem?.store_product_properties,
                        store_service_properties:
                          productItem?.store_service_properties,
                      }),
                    );
                    triggerToast("Item added to cart", "success");
                    setShowAddToCartModal(null);
                  }}
                >
                  {`Add ${quantity} item${quantity > 1 ? "(s)" : ""} to cart (${
                    productItem?.store?.currency_code
                  } ${formatCurrency({ value: pricingDetails?.unit_price * quantity, currencyCode: productItem?.store?.currency_code })})`}
                </primaryComponents.Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </secondaryComponents.Modal>
  );
};

export default AddToCartModal;
